import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'

export const StyledMessageWrapper = styled(Flexbox)<{$isOwnMessage: boolean}>(
    ({$isOwnMessage, theme: {spacing}}) => css`
        width: 100%;
        justify-content: flex-start;
        align-items: flex-end;
        flex-direction: ${$isOwnMessage ? 'row-reverse' : 'row'};
        gap: ${spacing}px;
        margin-bottom: ${spacing * 4}px;
    `
)

export const StyledMessageItem = styled.div<{$isOwnMessage: boolean}>(
    ({$isOwnMessage, theme: {spacing, palette}}) => css`
        padding: ${spacing * 3}px;
        background-color: ${$isOwnMessage ? palette.neutral.white : palette.neutral[100]};
        color: ${palette.neutral[900]};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        max-width: 70%;
        min-width: 60%;
        word-wrap: break-word;
        position: relative;
    `
)

export const StyledMessageText = styled(Text)(
    ({theme: {spacing}}) => css`
        padding-top: ${spacing}px;
        white-space: pre-wrap;
    `
)

// WhatsApp-like placeholder shown in place of a deleted message's content
export const StyledDeletedMessageText = styled(Text)(
    ({theme: {spacing}}) => css`
        padding-top: ${spacing}px;
        font-style: italic;
    `
)

export const StyledUrgentTagIcon = styled(AlertCircleIcon)(
    ({theme: {palette}}) => css`
        fill: ${palette.warning[600]};
    `
)
